import { render, staticRenderFns } from "./PayDetail.vue?vue&type=template&id=55ffd51d&scoped=true"
import script from "./PayDetail.vue?vue&type=script&lang=js"
export * from "./PayDetail.vue?vue&type=script&lang=js"
import style0 from "./PayDetail.vue?vue&type=style&index=0&id=55ffd51d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffd51d",
  null
  
)

export default component.exports